import {createStyles, makeStyles} from '@material-ui/core';

const styles = makeStyles((theme) =>
    createStyles({
        help: {
            color: theme.palette.text.disabled,
        },
        leftBullets: {
            listStylePosition: 'inside',
            paddingLeft: 0,
        },
        secondaryLink: {
            color: theme.palette.secondary.dark,
            fontWeight: 'bold',
            cursor: 'pointer',
        },
        link: {
            cursor: 'pointer',
        },
    })
);

export default styles;
